import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLabels } from 'wsm-common-data';
import './SimpleView.scss';

const ImageAttribute = ({ attr }) => {
	const [hasError, setHasError] = useState(false);
	const imgRef = useRef(null);

	useEffect(() => {
		if (imgRef.current?.complete && imgRef.current?.naturalWidth === 0) {
			setHasError(true);
		}
	}, []);

	return (
		<a
			href={attr.linkUrl}
			className={`simple-view-attribute__image-link${hasError ? ' simple-view-attribute__image-link--error' : ''}`}
			data-testid={`simple-view-attribute-${attr.name}-link`}
		>
			<img
				ref={imgRef}
				src={attr.imageUrl}
				alt={attr.alt || attr.label}
				className="simple-view-attribute__image"
				onError={() => setHasError(true)}
			/>
		</a>
	);
};

ImageAttribute.propTypes = {
	attr: PropTypes.shape({
		name: PropTypes.string.isRequired,
		label: PropTypes.string,
		alt: PropTypes.string,
		imageUrl: PropTypes.string,
		linkUrl: PropTypes.string
	}).isRequired
};

const SimpleView = () => {
	const { simpleViewAttributes } = useSelector((state) => state);
	const labels = useLabels();
	const [isCertified, setIsCertified] = useState(false);

	useEffect(() => {
		const inventoryType =
			window.DDC?.dataLayer?.vehicles?.at(0)?.inventoryType;
		setIsCertified(inventoryType === 'certified');
	}, []);

	if (!simpleViewAttributes || !simpleViewAttributes.length) {
		return null;
	}

	const visibleAttributes = isCertified
		? simpleViewAttributes
		: simpleViewAttributes.filter(
				(attr) =>
					attr.name !== 'warranty' && attr.name !== 'inspectionStatus'
		  );

	const attrCount = visibleAttributes.length;
	const mdColClass = attrCount >= 3 ? 'simple-view-attributes--3-col-md' : '';
	return (
		<div className="simple-view">
			{isCertified && labels.get('CERTIFIED_CONTENT_LABEL') && (
				<p className="simple-view-certified-content">
					{labels.get('CERTIFIED_CONTENT_LABEL')}
				</p>
			)}
			<div
				className={`simple-view-attributes ${mdColClass}`}
				data-testid="simple-view-attributes"
			>
				{visibleAttributes.map((attr) => (
					<div
						key={attr.name}
						className="simple-view-attribute"
						data-testid={`simple-view-attribute-${attr.name}`}
					>
						<span className="simple-view-attribute__label">
							{attr.label}
						</span>
						{attr.imageUrl ? (
							<ImageAttribute attr={attr} />
						) : (
							<span className="simple-view-attribute__value">
								{attr.value}
							</span>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default SimpleView;
